import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "D:\\www\\git\\new-multiple-merchant-vue\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "D:\\www\\git\\new-multiple-merchant-vue\\node_modules\\core-js\\modules\\es6.promise.js";
import "D:\\www\\git\\new-multiple-merchant-vue\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "D:\\www\\git\\new-multiple-merchant-vue\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from 'vue';
import Cookies from 'js-cookie';
import 'normalize.css/normalize.css'; // a modern alternative to CSS resets

import Element from 'element-ui';
import Moment from 'moment';
import cascader from 'element-ui/lib/cascader';
import "./styles/element-variables.scss";
import 'viewerjs/dist/viewer.css';
import '@/styles/index.scss'; // global css
import '@/styles/iconfont/iconfont.css';
import '@/styles/iconfont2/iconfont.css';
import '@/styles/fonts/font.css';
// 懒加载
import VueLazyload from 'vue-lazyload';
import App from "./App";
import store from "./store";
import router from "./router";
import Viewer from 'v-viewer';
import FormCreate from '@form-create/element-ui';
import uploadPicture from "./components/uploadPicture/uploadFrom";
import VueUeditorWrap from 'vue-ueditor-wrap';
import attrFrom from "./components/attrFrom";
import base from "./components/base/index"; // 公共组件
import templatesFrom from "./components/templatesFrom";
import couponList from "./components/couponList";
import "./icons"; // icon
import "./permission"; // permission control
// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import modalForm from '@/libs/modal-form';
import modalAttr from '@/libs/modal-attr';
import modalTemplates from '@/libs/modal-templates';
import videoCloud from '@/utils/videoCloud';
import modalCoupon from '@/libs/modal-coupon';
import { modalSure } from '@/libs/public';
import { modalSureDelete } from '@/libs/public';
import { handleDeleteTable } from '@/libs/public';
import { VueJsonp } from 'vue-jsonp';
import * as filters from "./filters"; // global filters modalTemplates
import notice from '@/libs/notice'; // global filters
import guidancePop from '@/components/guidancePop';
import { getToken } from "./utils/auth";
import { getBaseInfo } from '@/api/user';
import { roterPre } from '@/settings';
Vue.prototype.bus = new Vue();
Vue.use(uploadPicture);
Vue.use(base);
Vue.use(FormCreate);
Vue.use(VueJsonp);
Vue.use(VueAwesomeSwiper);
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require("./assets/images/no.png"),
  loading: require("./assets/images/moren.jpg"),
  attempt: 1,
  listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove']
});
Vue.component('vue-ueditor-wrap', VueUeditorWrap);
Vue.component('attrFrom', attrFrom);
Vue.component('templatesFrom', templatesFrom);
Vue.component('couponList', couponList);
Vue.prototype.$modalForm = modalForm;
Vue.prototype.$modalSure = modalSure;
Vue.prototype.$videoCloud = videoCloud;
Vue.prototype.$modalSureDelete = modalSureDelete;
Vue.prototype.handleDeleteTable = handleDeleteTable;
Vue.prototype.$modalAttr = modalAttr;
Vue.prototype.$modalTemplates = modalTemplates;
Vue.prototype.$modalCoupon = modalCoupon;
Vue.prototype.moment = Moment;
Vue.component('guidancePop', guidancePop);
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
});
Vue.use(cascader);

// register global utility filters
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});
var _hmt = _hmt || [];
// 商户信息检查相关变量
var merchantInfoCheckTimer = null;
var merchantInfoChecked = false; // 本次会话是否已检查过

router.beforeEach(function (to, from, next) {
  /* 路由发生变化修改页面title */
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
  if (to.meta.title) {
    var merInfo = Cookies.get('MerInfo');
    if (merInfo) {
      try {
        var merInfoObj = JSON.parse(merInfo);
        document.title = to.meta.title + '-' + (merInfoObj.merchant_login_title || '');
      } catch (e) {
        document.title = to.meta.title;
      }
    } else {
      document.title = to.meta.title;
    }
  }

  // 全局商户信息检查（排除商户信息页面）
  if (to.name !== 'ModifyStoreInfo' && to.path !== "".concat(roterPre, "/systemForm/modifyStoreInfo") && getToken()) {
    // 清除之前的定时器
    if (merchantInfoCheckTimer) {
      clearTimeout(merchantInfoCheckTimer);
    }
    // 防抖处理，300ms 后检查
    merchantInfoCheckTimer = setTimeout(function () {
      getUserMessage();
    }, 300);
  } else {
    // 如果进入商户信息页面，重置检查标志
    if (to.name === 'ModifyStoreInfo' || to.path === "".concat(roterPre, "/systemForm/modifyStoreInfo")) {
      merchantInfoChecked = false;
    }
  }
  next();
});

/**
 * 全局商户信息检查
 */
function getUserMessage() {
  // 如果本次会话已检查过，跳过
  if (merchantInfoChecked) {
    return;
  }
  getBaseInfo().then(function (res) {
    var resData = res.data;
    if (!resData.mer_avatar || !resData.mer_banner || !resData.mer_info || !resData.mer_address) {
      merchantInfoChecked = true; // 标记已检查
      Vue.prototype.$alert('您好，请前往左侧菜单【设置】-【商户信息】完善商户基础信息', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          router.push({
            name: 'ModifyStoreInfo'
          });
        }
      });
    }
    var marginRemain = window.localStorage.getItem('marginRemain');
    store.commit('user/SET_MARGIN_STATUS', resData.margin_remind_status);
    if (resData.margin_remind_status) {
      if (marginRemain === 0) {
        Vue.prototype.$confirm('店铺保证金不足，为保证您正常使用，请尽快去补缴！', '提示', {
          confirmButtonText: '去补缴',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          window.localStorage.setItem('marginRemain', 1);
          router.push({
            name: 'ModifyStoreInfo'
          });
        }).catch(function () {
          window.localStorage.setItem('marginRemain', 1);
        });
      }
    }
  }).catch(function () {
    // 忽略错误，避免影响路由跳转
  });
}
var token = getToken();
var _notice;
if (token) {
  _notice = notice(token);
}
Vue.config.productionTip = false;
export default new Vue({
  el: '#app',
  data: {
    notice: _notice
  },
  methods: {
    closeNotice: function closeNotice() {
      this.notice && this.notice();
    }
  },
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
});